import * as React from "react"
import { cn } from "../../lib/utils"

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "info"
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = "default", ...props }, ref) => {
    const variantStyles = {
      default: "bg-slate-900 text-slate-50 hover:bg-slate-900/80",
      secondary: "bg-slate-100 text-slate-900 hover:bg-slate-100/80",
      destructive: "bg-red-500 text-slate-50 hover:bg-red-500/80",
      outline: "text-slate-950 border border-slate-200",
      success: "bg-green-500 text-slate-50 hover:bg-green-500/80",
      warning: "bg-yellow-500 text-slate-900 hover:bg-yellow-500/80",
      info: "bg-blue-500 text-slate-50 hover:bg-blue-500/80",
    }

    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex items-center rounded-none border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2",
          variantStyles[variant],
          className
        )}
        {...props}
      />
    )
  }
)
Badge.displayName = "Badge"

export { Badge }
